<template>
  <div id="page" class="rtl" :class="(isIOS ? 'op_ios' : '')">

    <!-- <LoginPage v-if="show_login" /> -->

    <main v-if="loaded"> 
      <Header v-if="$store.user && ($route.name !== 'homepage' && $route.name !== 'login')" :menu="menu" />
      <HeaderHome v-if="$route.name === 'profile' || $route.name === 'homepage' || ($route.name === 'friends' && !user)" />
      <div id="content">

        <router-view v-slot="{ Component }" @loaded="is_show_loader=false;" @show_loader="is_show_loader=true;">
          <transition name="fade">
            <component :is="Component" :key="$route.path" />
          </transition>
        </router-view>

      </div>
      <FooterHome v-if="$route.path === '/'" />
    </main>
   
    <!-- <Share /> -->

    <div id="loading_animation" v-if="is_show_loader || !loaded"><div id="spinner_ajax"></div></div>
    
    <!-- Fixed Loader Component -->
    <FixedLoader />
  </div>
</template>

<script>
import Header from './components/global/header.vue'
import HeaderHome from './components/global/headerHome.vue'
import FooterHome from './components/global/footerHome.vue'
import FixedLoader from './components/global/FixedLoader.vue'

// import Share from './components/share.vue'


export default {
  name: 'app',
  components: { Header, HeaderHome, FooterHome, FixedLoader },
  data(){
    return {
      loaded: false,
      menu: [],
      is_show_loader: false,
      user: false,
      show_login:false,
      notRequireLoginRoutes: ['homepage', 'login', 'friends', 'project', 'profile']
    }
  },
  mounted() { 
    
    window.appVue = this;
    this.$bus.$on('reload', (openURL) => { this.reload(openURL); });
    this.reloadPage();
  },
  methods:{
    
    reload(openURL){
      this.loaded=false;
      if (this.isNull(openURL)) openURL = '/';

      if (this.$route.path !== '/') this.$router.push(openURL);
      else this.$router.go(0);
      //this.refreshKey++;
      this.reloadPage();
    },
    reloadPage(){

      let getVars = {};
      let uri = window.location.href.split('?');
      if(uri.length == 2) {
        let vars = uri[1].split('&');
        
        let tmp = '';
        vars.forEach(function(v) {
          tmp = v.split('=');
          if(tmp.length == 2)
            getVars[tmp[0]] = tmp[1];
        });
        // do 
      }

      if(!this.isNull(getVars.token))
      {
        this.set_user_token(getVars.token);
        document.location = '/'
      }
      

      // categories
      this.api({ action: 'general'}, (data) => { 

        this.menu = data.data.menu;
        
        //this.foot_line = data.data.foot_line;
        this.$store.words = data.data.words;
        this.$store.last_updates = data.data.last_updates;
        //this.$store.footer_articles = data.data.footer_articles;

        this.$store.user = data.data.user;
        this.user = data.data.user;
        if (!this.user && this.$route.name != 'homepage' && !this.notRequireLoginRoutes.includes(this.$route.name)) {
          this.logout()
        }

        if (this.isNull(data.data.user) || data.data.user === false)
        {
          localStorage.removeItem('user_token');
          this.show_login=true;
        }

        if (this.user) {
          if (this.$route.name == 'homepage') {
            if (this.user.type === "entrepreneur") {
              this.$router.push({ name: 'projects' });
            }
            if (this.user.type === "lawyer") {
              this.$router.push({ name: 'projects_manager' });
            }
          }
        }
        
        this.loaded = true;
        // self.show_splash_screen = false;
      });



       this.api({ action: 'get_lists', data: {ids : [2126,2123,1446,1443,1440,1437,1418,1454,1457,1460,1505,1449,1431]}}, (data)=>{
        this.$store.airdirections = data.data[1418];
        this.$store.ownerships = data.data[1454];
        console.log(this.$store.ownerships, "ownerships");
        
        this.$store.population_type = data.data[2123];
        this.$store.apartment_types = data.data[2126];
        this.$store.spe_notes = data.data[1457];
        this.$store.prop_types = data.data[1460];
        this.$store.activity_areas_country = data.data[1505];
        this.$store.representation_type = data.data[1449];
        this.$store.classification_type = data.data[1431];
        this.$store.banks_financial_support = data.data[1437];
        this.$store.insurance_companies = data.data[1440];
        this.$store.financing_companies = data.data[1443];
        this.$store.expertise = data.data[1446];
      });
    },
  }
}
</script>


<style lang="scss">
#page {
  &:has(.main_header) {
    #content {
      &>div {

        padding-top: calc(var(--headerHeight) + var(--gap_big));
      }
    }
  }
  &:has(#main_login_signup) {
    #content {
      padding: 0;
    }
  }
}
#content { background: var(--pageBG);
  min-height: 100vh;
  &>div { padding-top: calc( var(--gap_big));  min-height: 100vh;
    // background: var(--pageBG);
  }
}
</style>